import _objectWithoutProperties from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["id"];
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { SortOrderEnum, ValidationStatus, formatDate, formatSnakeCase, handleRequestError, toCapitalCase } from '@jove-frontend/uikit';
import qs from 'qs';
import { api } from '.';
export var apiGetOrganizationCandidates = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var organizationId, email, limit, offset, _ref$sortOrder, sortOrder, _ref$sortColumn, sortColumn, _ref$name, name, _ref$status, status, candidate_type, organization_ids, candidate_category, contractor_type, params, statuStr, subOrganizationIdStr, res, list, _err$response$data$de, _err$response, _err$response$data, _err$response$data$de2, _err$response$data$de3, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            organizationId = _ref.organizationId, email = _ref.email, limit = _ref.limit, offset = _ref.offset, _ref$sortOrder = _ref.sortOrder, sortOrder = _ref$sortOrder === void 0 ? SortOrderEnum.ASC : _ref$sortOrder, _ref$sortColumn = _ref.sortColumn, sortColumn = _ref$sortColumn === void 0 ? 'full_name' : _ref$sortColumn, _ref$name = _ref.name, name = _ref$name === void 0 ? '' : _ref$name, _ref$status = _ref.status, status = _ref$status === void 0 ? '' : _ref$status, candidate_type = _ref.candidate_type, organization_ids = _ref.organization_ids, candidate_category = _ref.candidate_category, contractor_type = _ref.contractor_type;
            _context.prev = 1;

            if (organizationId) {
              _context.next = 4;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 4:
            params = {
              email: email,
              limit: limit,
              offset: offset,
              sort_column: sortColumn,
              sort_order: sortOrder,
              candidate_type: candidate_type
            };
            if (name) params['name'] = name;

            if (candidate_category) {
              params['candidate_category_id'] = candidate_category;
            }

            if (contractor_type) {
              params['contractor_type'] = contractor_type;
            }

            statuStr = status ? "&".concat(status) : '';
            subOrganizationIdStr = organization_ids ? "&".concat(organization_ids) : '';
            _context.next = 12;
            return api.get("/organizations/".concat(organizationId, "/candidates?").concat(qs.stringify(params)).concat(statuStr).concat(subOrganizationIdStr));

          case 12:
            res = _context.sent;

            // TODO - This should only handle API calls - NO DATA MANIPULATION SHOULD BE DONE HERE !!
            // Please move this to the store
            if (res.data && Array.isArray(res.data.data)) {
              list = [];
              res.data.data.forEach(function (item) {
                var _temp$validation_stat;

                var temp = _objectSpread({}, item); // Contract duration


                temp.contractDurationText = formatDate({
                  date: temp.start_date,
                  options: {
                    month: 'short'
                  }
                });

                if (temp.end_date) {
                  temp.contractDurationText += " - ".concat(formatDate({
                    date: temp.end_date,
                    options: {
                      month: 'short'
                    }
                  }));
                } else {
                  temp.contractDurationText += " - Always on";
                } // lastUpdatedAt


                temp.lastUpdatedAtText = formatDate({
                  date: temp.updated_at,
                  options: {
                    hour: 'numeric',
                    minute: 'numeric'
                  }
                }); // validate status

                temp.validationStatusText = toCapitalCase(formatSnakeCase((_temp$validation_stat = temp.validation_status) !== null && _temp$validation_stat !== void 0 ? _temp$validation_stat : ValidationStatus.NOT_STARTED)); // status can do flag

                temp.canInvite = [ValidationStatus.NOT_STARTED, ValidationStatus.IMPORTED, ValidationStatus.INVITATION_CREATED].includes(temp.validation_status);
                temp.canEdit = !temp.validation_status || ![ValidationStatus.NOT_STARTED, ValidationStatus.IMPORTED, ValidationStatus.IN_PROGRESS].includes(temp.validation_status);
                temp.validateFail = false;
                list.push(temp);
              });
              res.data.data = list;
            }

            return _context.abrupt("return", [res.data]);

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](1);
            message = (_err$response$data$de = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data.detail) === null || _err$response$data$de2 === void 0 ? void 0 : (_err$response$data$de3 = _err$response$data$de2[0]) === null || _err$response$data$de3 === void 0 ? void 0 : _err$response$data$de3.msg) !== null && _err$response$data$de !== void 0 ? _err$response$data$de : _context.t0;
            console.error("Failed to retrieve candidates: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 17]]);
  }));

  return function apiGetOrganizationCandidates(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiInviteCandidate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(organizationId, args) {
    var res, _err$response$data$de4, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;

            if (organizationId) {
              _context2.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context2.next = 5;
            return api.post("/organizations/".concat(organizationId, "/invitations"), _objectSpread({}, args));

          case 5:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data.invitation]);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response$data$de4 = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg) !== null && _err$response$data$de4 !== void 0 ? _err$response$data$de4 : _context2.t0;
            console.error("Failed to send candidate invitation: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 9]]);
  }));

  return function apiInviteCandidate(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var apiNewInviteCandidate = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(organizationId, args) {
    var res, _err$response$data$de5, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (organizationId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context3.next = 5;
            return api.post("/organizations/".concat(organizationId, "/invitations"), _objectSpread({}, args));

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response$data$de5 = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg) !== null && _err$response$data$de5 !== void 0 ? _err$response$data$de5 : _context3.t0;
            console.error("Failed to send candidate invitation: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function apiNewInviteCandidate(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiUpdateCandidateInvitation = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(organizationId, invitationId, args) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (organizationId) {
              _context4.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            if (invitationId) {
              _context4.next = 5;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 5:
            _context4.next = 7;
            return api.patch("/organizations/".concat(organizationId, "/invitations/").concat(invitationId), _objectSpread({}, args));

          case 7:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 11:
            _context4.prev = 11;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError({}));

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 11]]);
  }));

  return function apiUpdateCandidateInvitation(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiGetCandidateInvitations = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6) {
    var organizationId, _ref6$limit, limit, _ref6$offset, offset, invitationIdList, params, res, _err$response$data$de6, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            organizationId = _ref6.organizationId, _ref6$limit = _ref6.limit, limit = _ref6$limit === void 0 ? 1000 : _ref6$limit, _ref6$offset = _ref6.offset, offset = _ref6$offset === void 0 ? 0 : _ref6$offset, invitationIdList = _ref6.invitationIdList;
            _context5.prev = 1;
            params = new URLSearchParams();
            params.append('limit', limit.toString());
            params.append('offset', offset.toString());
            invitationIdList === null || invitationIdList === void 0 ? void 0 : invitationIdList.forEach(function (id) {
              return params.append('invitation_id', id);
            });
            _context5.next = 8;
            return api.get("/organizations/".concat(organizationId, "/invitations"), {
              params: params
            });

          case 8:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data]);

          case 12:
            _context5.prev = 12;
            _context5.t0 = _context5["catch"](1);
            message = (_err$response$data$de6 = (_err$response4 = _context5.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg) !== null && _err$response$data$de6 !== void 0 ? _err$response$data$de6 : _context5.t0;
            console.error("Failed to retrieve candidate invitations: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 12]]);
  }));

  return function apiGetCandidateInvitations(_x9) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiGetCandidateInvitation = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(invitationId, organizationId) {
    var res, _err$response$data$de7, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;

            if (organizationId) {
              _context6.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            if (invitationId) {
              _context6.next = 5;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 5:
            _context6.next = 7;
            return api.get("/organizations/".concat(organizationId, "/invitations/").concat(invitationId));

          case 7:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response$data$de7 = (_err$response5 = _context6.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg) !== null && _err$response$data$de7 !== void 0 ? _err$response$data$de7 : _context6.t0;
            console.error("Failed to retrieve invitation: ".concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 11]]);
  }));

  return function apiGetCandidateInvitation(_x10, _x11) {
    return _ref8.apply(this, arguments);
  };
}();
export var apiResendCandidateInvitationEmail = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(organizationId, invitationId) {
    var res, _err$response$data$de8, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            if (organizationId) {
              _context7.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            if (invitationId) {
              _context7.next = 5;
              break;
            }

            throw new Error("Invalid invitation id: ".concat(invitationId));

          case 5:
            _context7.next = 7;
            return api.post("/organizations/".concat(organizationId, "/invitations/").concat(invitationId, "/resend"));

          case 7:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data]);

          case 11:
            _context7.prev = 11;
            _context7.t0 = _context7["catch"](0);
            message = (_err$response$data$de8 = (_err$response6 = _context7.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg) !== null && _err$response$data$de8 !== void 0 ? _err$response$data$de8 : _context7.t0;
            console.error("Failed to resend invitation email: ".concat(message));
            return _context7.abrupt("return", [null, _context7.t0]);

          case 16:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 11]]);
  }));

  return function apiResendCandidateInvitationEmail(_x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiSendBulkInvitations = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(organizationId, payload) {
    var res, _err$response$data$de9, _err$response7, _err$response7$data, _err$response7$data$d, _err$response7$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            if (organizationId) {
              _context8.next = 3;
              break;
            }

            throw new Error("Invalid organization id: ".concat(organizationId));

          case 3:
            _context8.next = 5;
            return api.patch("/organizations/".concat(organizationId, "/batch_invitations"), payload);

          case 5:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](0);
            message = (_err$response$data$de9 = (_err$response7 = _context8.t0.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$data = _err$response7.data) === null || _err$response7$data === void 0 ? void 0 : (_err$response7$data$d = _err$response7$data.detail) === null || _err$response7$data$d === void 0 ? void 0 : (_err$response7$data$d2 = _err$response7$data$d[0]) === null || _err$response7$data$d2 === void 0 ? void 0 : _err$response7$data$d2.msg) !== null && _err$response$data$de9 !== void 0 ? _err$response$data$de9 : _context8.t0;
            console.error("Failed to send bulk invitations: ".concat(message));
            return _context8.abrupt("return", [null, _context8.t0]);

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 9]]);
  }));

  return function apiSendBulkInvitations(_x14, _x15) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiGetCandidate = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(candidateId, token) {
    var res, _err$response8, _err$response8$data, _err$response8$data$d, _err$response8$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;

            if (candidateId) {
              _context9.next = 3;
              break;
            }

            throw new Error('No candidate id is provided');

          case 3:
            _context9.next = 5;
            return api.get("/candidates/".concat(candidateId), {
              params: {
                token: token
              }
            });

          case 5:
            res = _context9.sent;
            return _context9.abrupt("return", [res.data.data.candidate]);

          case 9:
            _context9.prev = 9;
            _context9.t0 = _context9["catch"](0);
            message = (_err$response8 = _context9.t0.response) === null || _err$response8 === void 0 ? void 0 : (_err$response8$data = _err$response8.data) === null || _err$response8$data === void 0 ? void 0 : (_err$response8$data$d = _err$response8$data.detail) === null || _err$response8$data$d === void 0 ? void 0 : (_err$response8$data$d2 = _err$response8$data$d[0]) === null || _err$response8$data$d2 === void 0 ? void 0 : _err$response8$data$d2.msg;
            console.error("Failed to fetch candidate ".concat(candidateId, " : ").concat(message));
            return _context9.abrupt("return", [null, _context9.t0]);

          case 14:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 9]]);
  }));

  return function apiGetCandidate(_x16, _x17) {
    return _ref11.apply(this, arguments);
  };
}();
export var apiUpdateCandidate = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(candidate, token) {
    var id, payload, res, _err$response9, _err$response9$data, _err$response9$data$d, _err$response9$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;

            if (candidate !== null && candidate !== void 0 && candidate.id) {
              _context10.next = 3;
              break;
            }

            throw new Error('No candidate id was provided');

          case 3:
            id = candidate.id, payload = _objectWithoutProperties(candidate, _excluded);
            _context10.next = 6;
            return api.patch("/candidates/".concat(id), payload, {
              params: {
                token: token
              }
            });

          case 6:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data.data.candidate]);

          case 10:
            _context10.prev = 10;
            _context10.t0 = _context10["catch"](0);
            message = (_err$response9 = _context10.t0.response) === null || _err$response9 === void 0 ? void 0 : (_err$response9$data = _err$response9.data) === null || _err$response9$data === void 0 ? void 0 : (_err$response9$data$d = _err$response9$data.detail) === null || _err$response9$data$d === void 0 ? void 0 : (_err$response9$data$d2 = _err$response9$data$d[0]) === null || _err$response9$data$d2 === void 0 ? void 0 : _err$response9$data$d2.msg;
            console.error("Failed to update candidate ".concat(candidate === null || candidate === void 0 ? void 0 : candidate.id, " : ").concat(message));
            return _context10.abrupt("return", [null, _context10.t0]);

          case 15:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 10]]);
  }));

  return function apiUpdateCandidate(_x18, _x19) {
    return _ref12.apply(this, arguments);
  };
}();
export var apiUpdateSupplierInvitation = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(organizationId, invitationId, args) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.patch("/msp/supplier/".concat(organizationId, "/invitations/").concat(invitationId), _objectSpread({}, args));

          case 3:
            res = _context11.sent;
            return _context11.abrupt("return", [res.data]);

          case 7:
            _context11.prev = 7;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError({}));

          case 10:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 7]]);
  }));

  return function apiUpdateSupplierInvitation(_x20, _x21, _x22) {
    return _ref13.apply(this, arguments);
  };
}();